"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INITIAL_STATE = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const color = require("color");
const React = require("react");
const react_i18next_1 = require("react-i18next");
const package_1 = require("../package");
const VirtualTourComponent_1 = require("./VirtualTourComponent");
const styles = (theme) => (0, core_1.createStyles)({
    virtualTourModal: {
        color: theme.palette.common.black,
        marginTop: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            width: '100%'
        }
    },
    withMargins: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2.5)
    },
    buttons: {
        width: theme.spacing(2),
        height: theme.spacing(2),
        color: color(theme.palette.common.black).alpha(0.54).rgb().string()
    }
});
exports.INITIAL_STATE = {
    tosChecked: false
};
class VirtualTourModal extends React.Component {
    constructor(props) {
        super(props);
        this.renderFeaturedSlide = (onclose) => ((0, jsx_runtime_1.jsx)(VirtualTourComponent_1.default, { content: package_1.config.internalConfig.VIRTUALTOUR, onClose: onclose }));
        this.state = Object.assign({}, exports.INITIAL_STATE);
    }
    render() {
        const { open, onClose, t } = this.props;
        return ((0, jsx_runtime_1.jsx)(package_1.InformationDialog, Object.assign({ title: t('arcade.tour.title'), open: open, maxWidth: 'lg', onClose: onClose, hideButton: true, noSpaces: true, titleColor: true, centerTitle: true }, { children: this.renderFeaturedSlide(onClose) })));
    }
}
exports.default = (0, core_1.withStyles)(styles)((0, react_i18next_1.withTranslation)()(VirtualTourModal));
//# sourceMappingURL=VirtualTourModal.js.map